import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import { isEmpty } from 'lodash';

import BobModal from '../../../components/BobModal';
import ContextualTab from './ContextualTab';
import TabComponent from '../../../components/TabComponent';
import ApplicationsTab from './ApplicationsTab';
import RolePermissionTab from './RolePermissionTab';
// import FunctionsTab from './FunctionsTab';
import UserType from './UserType';

import { dashboardContent } from '../../../localization/en-us/dashboardContent';

import classes from './userTabsContainer.module.css';
import createEntityClasses from '../CreateEntityModal.module.css';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const UserTabsContainer = ({
    createOrUpdateUser,
    history,
    isCreateUser,
    selectedUser,
    selectedUserTypeList,
    setSelectedUserTypeList,
    userFormattedAddress,
    userApplications,
    setUserApplications,
    userContactDetails,
    userTabIndex,
    setUserTabIndex,
    contextState,
    setContextState,
    onCancelClick,
    ...props
}) => {

    const [isTabDataDirty, setIsTabDataDirty] = useState(false);
    const [existingUserContext, setExistingUserContext] = useState({});
    const [isCompanyLevelAccess, setIsCompanyLevelAccess] = useState(false);
    const [uncheckedCompanyLevelAccess, setUncheckedCompanyLevelAccess] = useState(false);

    const handleChange = (event, newValue) => {
        // create time we can add multiple userType
        if (isCreateUser) {
            setUserTabIndex(newValue);
        } else {
            const unsavedUserType = selectedUserTypeList.filter(item => !item.id);

            // update time we can add only one userType at a time
            if (!isEmpty(unsavedUserType)) {
                setIsTabDataDirty(true);
            } else {
                setUserTabIndex(newValue);
            }
        }
    };

    /*let isValidCognitoId = false;
    if (!isEmpty(selectedUser)) {
        isValidCognitoId = selectedUser.cognitoId && selectedUser.cognitoId !== EMPTY_GUID ? true : false;
    }*/
    
    return (
        <div className={classes.TableContainer}>
            <div className={classes.root}>
                <Tabs
                    value={userTabIndex}
                    classes={{
                        indicator: classes.Indicator
                    }}
                    textColor="inherit"
                    onChange={handleChange}
                    aria-label="disabled tabs example"
                >
                    <Tab
                        classes={{
                            root:     classes.Tab,
                            selected: classes.ActiveTab
                        }}
                        label={dashboardContent.userType}
                        disableRipple
                    />
                    {/* no need this on create user time */}
                    {
                        /*!isEmpty(selectedUser) && isValidCognitoId ? */ 
                        !isEmpty(selectedUser) ? 
                            <Tab
                                classes={{
                                    root:     classes.Tab,
                                    selected: classes.ActiveTab
                                }}
                                label={dashboardContent.applications}
                                disableRipple
                            /> : null
                    }
                    {/* {
                        isValidCognitoId && process.env.userPermissionTabsEnabled ? 
                            <Tab
                                classes={{
                                    root:     classes.Tab,
                                    selected: classes.ActiveTab
                                }}
                                label={dashboardContent.contextual}
                                disableRipple
                            />: null
                    }
                    {
                        isValidCognitoId && process.env.userPermissionTabsEnabled ? 
                            <Tab
                                classes={{
                                    root:     classes.Tab,
                                    selected: classes.ActiveTab
                                }}
                                label={dashboardContent.rolePermission}
                                disableRipple
                            />: null
                    } */}
                    {/* <Tab
                        classes={{
                            root:     classes.Tab,
                            selected: classes.ActiveTab
                        }}
                        label={dashboardContent.functions}
                        disableRipple
                    /> */}
                </Tabs>
            </div>
            <div className={classes.GridContainer}>
                <TabComponent
                    value={userTabIndex}
                    index={0}
                >
                    <UserType
                        createOrUpdateUser={createOrUpdateUser}
                        isCreateUser={isCreateUser}
                        isTabDataDirty={isTabDataDirty}
                        selectedUser={selectedUser} 
                        selectedUserTypeList={selectedUserTypeList}
                        setSelectedUserTypeList={setSelectedUserTypeList}
                        setIsTabDataDirty={setIsTabDataDirty}
                        userFormattedAddress={userFormattedAddress}
                        userContactDetails={userContactDetails}
                    />
                </TabComponent>
                { 
                    !isCreateUser ?
                        <TabComponent
                            value={userTabIndex}
                            index={1}
                        >
                            <ApplicationsTab 
                                selectedUser={selectedUser}
                                userApplications={userApplications}
                                setUserApplications={setUserApplications}
                            />
                        </TabComponent>
                        : null
                }
                {/* <TabComponent
                    value={userTabIndex}
                    index={ isCreateUser ? 1 : 2}
                >
                    <ContextualTab 
                        selectedUser={selectedUser}
                        contextState={contextState}
                        setContextState={setContextState}
                        existingUserContext={existingUserContext}
                        isCompanyLevelAccess={isCompanyLevelAccess}
                        uncheckedCompanyLevelAccess={uncheckedCompanyLevelAccess}
                        setExistingUserContext={setExistingUserContext}
                        setIsCompanyLevelAccess={setIsCompanyLevelAccess}
                        setUncheckedCompanyLevelAccess={setUncheckedCompanyLevelAccess}
                    />
                </TabComponent>
                <TabComponent
                    value={userTabIndex}
                    index={isCreateUser ? 2 : 3}
                >
                    <RolePermissionTab 
                        selectedUser={selectedUser} 
                        userApplications={userApplications}
                        contextState={contextState}
                        setContextState={setContextState}
                        onCancelClick={onCancelClick}
                        existingUserContext={existingUserContext}
                        isCompanyLevelAccess={isCompanyLevelAccess}
                        uncheckedCompanyLevelAccess={uncheckedCompanyLevelAccess}
                        setExistingUserContext={setExistingUserContext}
                        setIsCompanyLevelAccess={setIsCompanyLevelAccess}
                        setUncheckedCompanyLevelAccess={setUncheckedCompanyLevelAccess}
                    />
                </TabComponent> */}
                {/* <TabComponent
                    value={userTabIndex}
                    index={2}
                >
                    <FunctionsTab selectedUser={selectedUser} />
                </TabComponent> */}
            </div>
            {
                isTabDataDirty ?
                    <BobModal
                        title={'Update Changes'}
                        applyHidden={true}
                        hidebuttons={true}
                        isRemoveFooter={true}
                        onClose={() => setIsTabDataDirty(false)}
                    >
                        <React.Fragment>
                            <ErrorOutlineIcon className={createEntityClasses.warningIcon} />
                            <div className={createEntityClasses.text}>
                                <p className={createEntityClasses.entityName}>Please update your changes to continue</p>
                            </div>
                            <Button
                                className={createEntityClasses.Button}
                                onClick={() => setIsTabDataDirty(false)}
                                variant="contained"
                            >
                                Cancel
                            </Button>
                        </React.Fragment>
                    </BobModal> : ''
            }
        </div>
    );
};

export default UserTabsContainer;
